import { render, staticRenderFns } from "./SelectUserType.vue?vue&type=template&id=616c04c7"
import script from "./SelectUserType.vue?vue&type=script&lang=js"
export * from "./SelectUserType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports